import { TiffConverterPage } from '@/features/tiff-converter'
import { useT } from '@/shared/i18n'

export function TiffToJpgPage() {
  const t = useT()

  return <TiffConverterPage copy={t.tiffToJpg} />
}
